import { CommonModule } from '@angular/common';
import { Component, input, model } from '@angular/core';
import { ToggleButton } from '@ntv360/component-pantry';

@Component({
    selector: 'app-accordion',
    standalone: true,
    imports: [CommonModule, ToggleButton],
    templateUrl: './accordion.component.html',
    styleUrl: './accordion.component.scss',
})
export class AccordionComponent {
    /** Whether the accordion is expanded. */
    public readonly expanded = model<boolean>(false);

    /** State of the toggle switch in the header. */
    public readonly isChecked = model<boolean>(false);

    /** Whether to show the toggle switch in the header. */
    public readonly showToggle = input<boolean>(true);

    /** Padding for the content area. */
    public readonly padding = input<string>('1.25rem 1.5rem');

    /** Icon tailwind color utility class. Defaults to `text-accent-main` */
    public iconTwColor = input<string>('text-accent-main');

    /** Toggles the expanded state. */
    protected toggleExpansion(): void {
        this.expanded.update((v) => !v);
    }

    /** Handle toggle switch change. */
    protected onToggle(event: boolean): void {
        this.isChecked.set(event);
    }
}
